import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { AttachmentsButton } from './AttachmentsButton/AttachmentsButton';
import BotCommandsList from './BotCommandsList';
import { CancelVoiceButton } from './CancelVoiceButton/CancelVoiceButton';
import { EditMessage } from './EditMessage/EditMessage';
import { useInputPanelPresenter } from './InputPanel.presenter';
import styles from './InputPanel.styles.m.css';
import { InputPanelButtons } from './InputPanelButtons/InputPanelButtons';
import { InputSection } from './InputSection/InputSection';
import LinkPreview from './LinkPreview';
import MentionList from './MentionList';
import { QuotedText } from './QuotedText/QuotedText';
import { PreviewRecord } from './RecordingSection/PreviewRecord/PreviewRecord';
import { ProgressRecord } from './RecordingSection/ProgressRecord/ProgressRecord';
import { RepliedMessage } from './RepliedMessage/RepliedMessage';

export const InputPanel: FC = observer(() => {
  const presenter = useInputPanelPresenter();

  return (
    <>
      {presenter.hasBotCommands && <BotCommandsList />}
      {presenter.canShowMentions && <MentionList />}
      {presenter.chanShowLinkPreview && <LinkPreview />}

      <RepliedMessage className={styles.topPanel} />
      <QuotedText className={styles.topPanel} />
      <EditMessage className={styles.topPanel} />

      <div className={styles.container}>
        {presenter.isShowRecordingVoice && (
          <>
            <CancelVoiceButton />
            <ProgressRecord className={styles.view} />
          </>
        )}

        {presenter.isShowPreviewVoice && (
          <>
            <CancelVoiceButton />
            <PreviewRecord className={styles.view} />
          </>
        )}

        {presenter.isShowInputPanel && (
          <>
            <AttachmentsButton />
            <InputSection className={styles.view} />
          </>
        )}

        <InputPanelButtons />
      </div>
    </>
  );
});
